import {
  startOfMonth,
  endOfMonth,
  startOfWeek,
  endOfWeek,
  subDays,
} from 'date-fns';

export const getDefaultRanges = (date) => {
  const today = new Date();


  const customStartDate = subDays(today, 60);
  // Define weekStarts On Monday
  const weekOptions = { weekStartsOn: 1 }; // 1 indicates Monday
  return [
    {
      label: 'This Week',
      startDate: startOfWeek(date, weekOptions),
      endDate: endOfWeek(date, weekOptions),
    },
    {
      label: 'This Month',
      startDate: startOfMonth(date),
      endDate: endOfMonth(date),
    },
    {
      label: 'Last 2 Months',
      startDate: customStartDate,
      endDate: today,
    },
    {
      label: 'Custom',
      startDate: null,
      endDate: null,
    },
  ];
};

export const defaultDateRanges = getDefaultRanges(new Date());
